import { render, staticRenderFns } from "./SlotReels.vue?vue&type=template&id=1823bd8b&scoped=true"
import script from "./SlotReels.vue?vue&type=script&lang=js"
export * from "./SlotReels.vue?vue&type=script&lang=js"
import style0 from "./SlotReels.vue?vue&type=style&index=0&id=1823bd8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1823bd8b",
  null
  
)

export default component.exports